const _ = require('lodash');
const i18n = require('swa-locale/i18n');
const Link = require('swa-components-core/link');
const Price = require('swa-currency/price');
const PropTypes = require('prop-types');
const React = require('react');
const urls = require('swa-bootstrap-data/urls');

class CorporateLandingHomePageDashboardFull extends React.Component {
    static propTypes = {
        availablePoints: PropTypes.number,
        dashboardName: PropTypes.string.isRequired,
        earnedPoints: PropTypes.number,
        rapidRewardsMaintenance: PropTypes.bool.isRequired,
        unusedFundsInd: PropTypes.bool
    };

    static defaultProps = {
        availablePoints: null,
        earnedPoints: null,
        unusedFundsInd: false
    };

    serviceAvailable = null;

    componentWillMount() {
        this.setRapidRewardsServiceAvailability();
    }

    render() {
        return (
            <div className="corporate-landing-home-page-dashboard-full">
                {this.renderGreeting()}
                {this.renderAvailablePoints()}
            </div>);
    }

    renderGreeting = () => (
        <div className="dashboard-full--greeting">
            <span className="dashboard-full--title dashboard-full--title_light">
                {`${i18n('TEXT__DASHBOARD__GREETING', { PART: 1 })} `}
                <span className="dashboard-full--title_emphasis">
                    {this.props.dashboardName}
                </span>
            </span>
            <span className="dashboard-full--description">
                {` ${i18n('TEXT__DASHBOARD__GREETING', { PART: 2 })}`}
            </span>
        </div>
    );

    renderAvailablePoints = () => (
        <div className="dashboard-full--points dashboard-full--points_available">
            {this.renderAvailablePointsPrice()}
            {this.getAvailablePointsText()}
            {this.renderEarnedPointsLink()}
        </div>
    );

    renderAvailablePointsPrice = () => ((this.serviceAvailable) ?
        <Price {...this.getPriceProps(this.props.availablePoints)} /> :
        <span className="dashboard-full--title dashboard-full--title_unavailable">
            {i18n('TEXT__DASHBOARD__POINTS_AVAILABLE__ERROR', { PART: 1 })}
        </span>)
        ;

    renderEarnedPointsLink = () => ((this.serviceAvailable) ?
        <Link {...this.getLinkProps('earnedPoints')}>
            {i18n('LINK__DASHBOARD__POINTS_EARNED')}
        </Link> : null);

    getAvailablePointsText = () => (
        <span className="dashboard-full--description">
            {(this.serviceAvailable) ?
                i18n('TEXT__DASHBOARD__POINTS_AVAILABLE') :
                i18n('TEXT__DASHBOARD__POINTS_AVAILABLE__ERROR', { PART: 2 })
            }
        </span>
    );

    getLinkProps = (itemName) => {
        const linkProps = {
            earnedPoints: {
                'aria-label': i18n('LINK__DASHBOARD__POINTS_EARNED__ARIA'),
                href: urls.CORPORATE__POINTS_EARNED
            }
        };

        return _.assign({
            className: 'dashboard-full--link',
            linkSize: 'extra-small',
            suffixIcon: 'swa-icon_arrow-right'
        }, _.get(linkProps, itemName));
    };

    getPriceProps = (value) => ({
        currencyCode: 'POINTS',
        displayType: 'tertiary',
        emphasis: true,
        maxValue: 999999999,
        price: 0,
        showSymbol: false,
        size: 'medium',
        textContent: value.toString()
    });

    setRapidRewardsServiceAvailability = () => {
        const { availablePoints, rapidRewardsMaintenance } = this.props;

        this.serviceAvailable = (!_.isNull(availablePoints) &&
            !rapidRewardsMaintenance
        );
    };
}

module.exports = CorporateLandingHomePageDashboardFull;
